var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-corner-ribbon"},[(!_vm.hidden)?_c('div',{staticClass:"px-corner-ribbon__label",attrs:{"data-label":_vm.label}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }